import { helper } from '@ember/component/helper';
import _truncateDelta from 'scaleflow/utils/truncate-delta';

export default helper(function truncateDelta([delta, maxLength = 160]) {
  return _truncateDelta(delta, maxLength);
});
